import { render, staticRenderFns } from "./TableSimpleBlock.vue?vue&type=template&id=31697668&"
import script from "./TableSimpleBlock.vue?vue&type=script&lang=js&"
export * from "./TableSimpleBlock.vue?vue&type=script&lang=js&"
import style0 from "./TableSimpleBlock.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports